import { coreAirports } from "./const";
import { CoreCityHasAirport, CoreCityHasOneAirport } from "./type";


export const getCityHasOneAirportByCode = (
  code: string
): CoreCityHasOneAirport | null => {
  const city = coreAirports[code as keyof typeof coreAirports];
  if (city) {
    return {
      ...city,
      airport: null,
    };
  } else {
    let foundCity: CoreCityHasOneAirport | null = null;
    for (const key in coreAirports) {
      const airportGroup = coreAirports[key as keyof typeof coreAirports];
      const foundAirport = airportGroup.airports.find(
        (airport) => airport.code === code
      );
      if (foundAirport) {
        foundCity = {
          ...airportGroup,
          airport: foundAirport,
        };
      }
    }
    return foundCity;
  }
};

export const searchCityHasAirportByKeyword = (
  keyword: string
): CoreCityHasAirport[] => {
  const trimmedKeyword = keyword.trim().toLowerCase();
  if (!trimmedKeyword) return [];

  const results: { city: CoreCityHasAirport; score: number }[] = [];

  for (const key in coreAirports) {
    const city = coreAirports[key as keyof typeof coreAirports];
    let score = 0;

    // City-level matching
    if (key.toLowerCase() === trimmedKeyword) score += 100;
    else if (key.toLowerCase().startsWith(trimmedKeyword)) score += 80;
    else if (key.toLowerCase().includes(trimmedKeyword)) score += 60;

    if (city.code.toLowerCase() === trimmedKeyword) score += 100;
    else if (city.code.toLowerCase().startsWith(trimmedKeyword)) score += 80;
    else if (city.code.toLowerCase().includes(trimmedKeyword)) score += 60;

    if (city.name.toLowerCase() === trimmedKeyword) score += 90;
    else if (city.name.toLowerCase().startsWith(trimmedKeyword)) score += 70;
    else if (city.name.toLowerCase().includes(trimmedKeyword)) score += 50;

    // Airport-level matching
    for (const airport of city.airports) {
      if (airport.code.toLowerCase() === trimmedKeyword) score += 90;
      else if (airport.code.toLowerCase().startsWith(trimmedKeyword))
        score += 70;
      else if (airport.code.toLowerCase().includes(trimmedKeyword)) score += 50;

      if (airport.name.toLowerCase() === trimmedKeyword) score += 60;
      else if (airport.name.toLowerCase().startsWith(trimmedKeyword))
        score += 40;
      else if (airport.name.toLowerCase().includes(trimmedKeyword)) score += 20;
    }

    if (score > 0) {
      results.push({ city, score });
    }
  }

  // Sort theo score giảm dần
  results.sort((a, b) => b.score - a.score);

  return results.map((r) => r.city);
};

export const getCityHasAirportDefault = (): CoreCityHasAirport[] => {
  const defaultCitiesCode = ["BJS", "HKG", "SHA", "TYO", "SFO", "NYC", "FRA"];
  const results: CoreCityHasAirport[] = [];
  for (const cityCode of defaultCitiesCode) {
    results.push(coreAirports[cityCode as keyof typeof coreAirports]);
  }
  return results;
}